<template>
    <section class="tekst yellow">
        <circles-layout class="yellow"></circles-layout>
        <h1>Positie in de regio</h1>
        <p>ROC Tilburg staat met twee benen in de Midden-Brabantse samenleving. Onze maatschappelijke opdracht is breed en divers. Om hier goed invulling aan te geven werken we samen met bedrijven, instellingen en gemeenten. Belangrijke activiteiten in 2020 voor dit strategisch doel zijn de deelname aan MindLabs en onze samenwerking met het Regionaal Mobiliteitsteam Arbeidsmarkt (RMA) en het Rangeerterrein. Hier vinden we aansluiting met de ontwikkelingen binnen bedrijven, instellingen en de arbeidsmarkt.</p>

        <p>Onderwijsgroep Tilburg verzorgt onderwijs aan jongeren en aan volwassenen. Het opleiden van werkende volwassenen in het kader van een leven lang leren is voor ons een belangrijke activiteit. Naast het opleiden van werkenden zien we een toenemende vraag naar opleidingen voor mensen met een afstand tot de arbeidsmarkt. In samenwerking met de Gemeente Tilburg en het UWV begeleiden we deze mensen weer naar werk.</p>

        <p>Dit is een belangrijke ontwikkeling in het kader van een leven lang ontwikkelen. De komende tijd blijven we hierin investeren zodat alle scholen een aanbod kunnen doen voor werkenden en mensen met een afstand tot de arbeidsmarkt.</p>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    export default {
        name: 'RegioIntro',
        meta: {
            title: 'RegioIntro',
            color: '#FEBE06'
        },
        components: {
            'circles-layout': Circles
        },
        methods: {
            focus()
            {
            }
        }
    };
</script>
